import { Component, Input, OnInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-request-access-modal',
  templateUrl: './request-access-modal.component.html',
  styleUrls: ['./request-access-modal.component.scss']
})
export class RequestAccessModalComponent implements OnInit {
  mailText: string;
  supportingMaterials = false;
  accessCode = false;
  accessRequiredLinks: string;
  @Input() assetName: any;
  isDisabled: boolean = true;
  @Input() accessCodePresent: boolean;

  constructor() { }

  ngOnInit(): void {
  }
  setFlags(links: string) {

    this.accessRequiredLinks = ''
    if (this.accessCodePresent) {
      if (links == 'Supporting Material') {
        this.supportingMaterials = !this.supportingMaterials;

      } else if (links == 'Access code') {
        this.accessCode = !this.accessCode;
      }
      if (this.supportingMaterials && this.accessCode) this.accessRequiredLinks = "asset's code repository and supporting materials"
      else if (this.supportingMaterials) this.accessRequiredLinks = "asset's supporting material"
      else if (this.accessCode) this.accessRequiredLinks = "asset's code repository"

    } else {
      this.accessCode = true;
      if (links == 'Supporting Material') {
        this.supportingMaterials = !this.supportingMaterials;
      }
      if (this.supportingMaterials) this.accessRequiredLinks = "asset's supporting material"
    }

    if (!this.supportingMaterials && !this.accessCode) {
      this.isDisabled = true;
    } else {
      this.isDisabled = false;
    }
  }

  openMailForAccessRequest() {

    if (this.supportingMaterials || this.accessCode) {
      this.supportingMaterials = false;
      this.accessCode = false;
      this.mailText = `mailto:IXDevHub.Support@accenture.com?subject=From Industry X Developer Hub: Request Access.
      &body=Hi,%0D%0A%0D%0AI would like to request access to the following `+ this.accessRequiredLinks + `:%0D%0AAsset Name: ` + this.assetName;
      window.location.href = this.mailText;
      this.isDisabled = true;
      $("#requestAccessModal").modal('hide');
    }
  }

}
